import React from "react";
import ContactUsBanner from "../components/contact/contact-us-banner";
import ContactForm from "../components/contact/contact-form";

const Contact = () => {
  return (
        <>
            <ContactUsBanner />
            <ContactForm />
        </>
  );
};

export default Contact;